module.exports = __webpack_public_path__ + "static/img/Raph.129273e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/board/Raph.jpg
// module id = 26on
// module chunks = 0